import * as React from 'react';
import { getTrackBackground, Range } from 'react-range';
import { formatDuration } from '../reporting_utils/misc';

const COLORS = ['#E5E5E5', '#007bff', '#E5E5E5'];

const durationOptions = [
  0, 5, 10, 15, 30, 45, 60, 120, 180, 240, 300, 600, 900, 1200, 1800, 2400, 3000, 3600,
];

/**
 * @param {{
 *   values: number[];
 *   onChange: (values: number[]) => void;
 * }} props
 */
export default function DurationRange({ values, onChange }) {
  const sliderValues = values.map((value) => {
    const optionIndex = durationOptions.findIndex((option) => option === value);
    if (optionIndex === -1) {
      throw new Error(
        `Invalid value: ${value} passed to DurationRange. You may only pass values defined in durationOptions.`
      );
    }
    return optionIndex;
  });

  return (
    <div>
      <div style={{ padding: 10 }}>
        <Range
          min={0}
          max={durationOptions.length - 1}
          step={1}
          values={sliderValues}
          onChange={(newSliderValues) => {
            const newValues = newSliderValues.map((optionIndex) => durationOptions[optionIndex]);
            onChange(newValues);
          }}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: 4,
                borderRadius: 12,
                width: '100%',
                background: getTrackBackground({
                  values: sliderValues,
                  colors: COLORS,
                  min: 0,
                  max: durationOptions.length - 1,
                }),
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              key={props.key}
              style={{
                ...props.style,
                height: 20,
                width: 20,
                borderRadius: 9999,
                backgroundColor: COLORS[1],
                boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
              }}
            />
          )}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-around' }}>
        <div style={{ display: 'flex' }}>
          <label style={{ marginBottom: 0 }}>Min:</label>
          <span style={{ paddingLeft: 4 }}>{formatDuration(values[0])}</span>
        </div>
        <div style={{ display: 'flex' }}>
          <label style={{ marginBottom: 0 }}>Max:</label>
          <span style={{ paddingLeft: 4 }}>
            {values[1] === 3600 ? 'Any' : formatDuration(values[1])}
          </span>
        </div>
      </div>
    </div>
  );
}
